import { render, staticRenderFns } from "./mediaTable.vue?vue&type=template&id=50426351&scoped=true"
import script from "./mediaTable.vue?vue&type=script&lang=ts"
export * from "./mediaTable.vue?vue&type=script&lang=ts"
import style0 from "./mediaTable.vue?vue&type=style&index=0&id=50426351&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50426351",
  null
  
)

export default component.exports